import dynamic from 'next/dynamic';
import { Fragment } from 'react';
import { NextSeo } from 'next-seo';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import HomeWidgetMobile from '../../components/home/HomeWidgetMobile';
import HomeCarousel from '../../components/home/HomeCarousel';
import HomeNews from '../../components/home/HomeNews';
import HomeUsefool from '../../components/home/HomeUsefool';
import HomeWidget from '../../components/home/HomeWidget';
import location from '../../data/location.json';

const HomeSEO = dynamic(() => import('../../components/home/HomeSEO'));

const HomePage = ({ region, currentLocation }) => {
  return (
    <Fragment>
      {<NextSeo
        title={currentLocation.seo.title}
        description={currentLocation.seo.description}
        openGraph={{
          url: `https://${process.env.NEXT_PUBLIC_SITEDOMAIN}`,
          type: 'website',
          title: currentLocation.seo.title,
          description: currentLocation.seo.description,
          images: [
            {
              url: '/images/og-preview.png'
            }
          ],
          site_name: process.env.NEXT_PUBLIC_SITENAME
        }}
      />}
      <Header region={region} />
      <main className="core">
        <HomeWidget region={region} />
        <HomeWidgetMobile region={region} />
        <HomeCarousel title="Рекомендуемые на вторичке" category="квартира" link="flats" />
        <HomeNews />
        <HomeCarousel title="Популярные в коммерции" category="коммерция" link="commercial" />
        <HomeUsefool region={region} locations={location} />
        <HomeSEO />
      </main>
      <Footer region={region} seo={['Купить недвижимость', currentLocation.seo.footer].join(' ')} />
    </Fragment>
  );
};
export async function getServerSideProps(context) {
  let newRegion = location.filter((v) => v.code === context.query.region)[0];

  if (!newRegion) return {
    notFound: true
  };
  //  newRegion = location.filter((v) => v.isDefault === true)[0];

  return {
    props: {
      region: newRegion.code,
      currentLocation: newRegion
    }
  }
}

export default HomePage;
